import axios from '@/axios';

export default {
  getOrderRequestApproval(_context, { requestId, token }) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/order-approval/' + requestId, { params: token ? { token } : {} })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },  

  updateOrderRequestApproval(_context, { requestId, status, approverId, notes, token }) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/v1/order-approval/${requestId}/status`, {
          status,
          approverId,
          notes,
        }, { params: token ? { token } : {} })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  createApprovalRequest(_context, data) {
      return axios.post('/api/v1/order-approval/create-request/', data);
  },
};
